const RELOAD_KEY = "anemoi:chunk-reload-at";
const RELOAD_THROTTLE_MS = 60_000;

const dynamicImportFailurePatterns = [
  /importing a module script failed/i,
  /failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /unable to preload css/i,
];

export function isDynamicImportFailure(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }
  return dynamicImportFailurePatterns.some((pattern) =>
    pattern.test(`${error.name} ${error.message}`),
  );
}

export function canReloadForChunkError(now: number = Date.now()): boolean {
  try {
    const raw = window.sessionStorage.getItem(RELOAD_KEY);
    if (raw === null) return true;
    const last = Number(raw);
    return !Number.isFinite(last) || now - last > RELOAD_THROTTLE_MS;
  } catch {
    return true;
  }
}

export function markChunkReload(now: number = Date.now()): void {
  try {
    window.sessionStorage.setItem(RELOAD_KEY, String(now));
  } catch {
    // sessionStorage unavailable (Safari private mode etc.) — proceed without throttle
  }
}
